import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ClubModel, CourtBookingInfoModel, CourtBookingInfoPlayerModel } from '@bayclubs/court-booking-employee-api';

import { ChangePlayerInputModel, ChangePlayerLauncherService } from '@players/players.module';
import { CourtBookingPlayerStatus } from '@shared-models/shared-models.module';

import { CourtEventInfoFacade } from './../../+store/court-event-info.facade';
import { CourtEventStatus } from './../../../shared-models/court-booking/enumerations';

@Component({
    selector: 'app-player-info-status',
    templateUrl: './player-info-status.component.html',
    styleUrls: ['./player-info-status.component.scss'],
    standalone: false
})
export class PlayerInfoStatusComponent implements OnInit {
    @Input() player: CourtBookingInfoPlayerModel;
    @Input() courtBooking: CourtBookingInfoModel;
    @Input() club: ClubModel;
    @Output() playerChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private courtEventInfoFacade: CourtEventInfoFacade,
        private playersChangeLauncher: ChangePlayerLauncherService
    ) { }

    ngOnInit(): void { }

    public get isPlayerChangeAvailable(): boolean {
        return (
            this.courtBooking.status.code === CourtEventStatus.confirmed.code &&
            this.player.status.code !== CourtBookingPlayerStatus.checkedIn.code &&
            !this.player.isBookingOwner
        );
    }

    public get isCheckInAvailable(): boolean {
        return (
            this.courtBooking.isCheckInPlayerAvailable &&
            (this.player.status.code !== CourtBookingPlayerStatus.noShow.code &&
                this.player.status.code !== CourtBookingPlayerStatus.checkedIn.code)
        );
    }

    public get isCheckedIn(): boolean {
        return this.player.status.code === CourtBookingPlayerStatus.checkedIn.code;
    }

    public get isNoShowed(): boolean {
        return this.player.status.code === CourtBookingPlayerStatus.noShow.code;
    }

    public get showStatusPanel(): boolean {
        return this.isCheckInAvailable || this.isPlayerChangeAvailable;
    }

    checkIn() {
        this.courtEventInfoFacade.checkInPlayer(this.courtBooking.courtBookingId, this.player.personId);
    }

    noShow() { }

    changePlayer() {
        this.playersChangeLauncher.openPlayersChangeModal({
            playerId: this.player.personId,
            courtId: this.courtBooking.court.courtId,
            courtBookingId: this.courtBooking.courtBookingId,
            categoryCode: this.courtBooking.categoryOptions.category.code,
            date: this.courtBooking.date,
            duration: this.courtBooking.timeToInMinutes - this.courtBooking.timeFromInMinutes
        } as ChangePlayerInputModel, () => this.playerChanged.emit(true));
    }
}
